// actions.js
export const FETCH_ROLES_REQUEST = 'FETCH_ROLES_REQUEST';

export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';

export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE';

export const fetchRolesRequest = (data) => ({ type: FETCH_ROLES_REQUEST, payload: data });

export const fetchRolesSuccess = (data) => ({ type: FETCH_ROLES_SUCCESS, payload: data });

export const fetchRolesFailure = (error) => ({ type: FETCH_ROLES_FAILURE, payload: error });